import {AnyAction} from 'redux';
import Types from '../../actions/Types';

import SoundCategory from '../../../domain/entities/SoundCategory';

export default function reducer(
  state: {[key: number]: SoundCategory} = {},
  action: AnyAction,
): {[key: number]: SoundCategory} {
  switch (action.type) {
    case Types.IndexSoundCategoriesSuccess:
      return {
        ...state,
        ...action.payload.records.reduceRight(
          (obj: {[key: number]: SoundCategory}, record: SoundCategory) => {
            obj[record.id] = record;
            return obj;
          },
          {},
        ),
      };
    case Types.ShowSoundCategorySuccess:
      return {
        ...state,
        [action.payload.id]: action.payload,
      };
    default:
      return state;
  }
}
